export default {
  title: 'Asetukset',
  reservation_hours_helper: 'Nämä ajat määrittävät, milloin vieraat voivat tehdä varauksia verkossa.',
  reservation_hours_alert:
    'Varausaikasi eroavat tavallisista aukioloajoistasi. Vieraat voivat varata vain näinä aikoina.',
  activated: 'Varaukset käytössä',
  deactivated: 'Varaukset pois käytöstä',
  buttons: {
    activate: 'Ota käyttöön',
    deactivate: 'Poista käytöstä',
  },
  error_messages: {
    no_google_place: {
      title: 'Ravintolaa ei ole yhdistetty mihinkään Google-sijaintiin',
      description: 'Yhdistä ravintola Google-sijaintiin',
    },
    toggle_failed: 'Varauksia ei voitu päivittää. Yritä uudelleen.',
  },
};
